"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var sizes = {
  s: {
    width: 11,
    height: 12
  },
  m: {
    width: 12,
    height: 14
  },
  l: {
    width: 16,
    height: 20
  }
};

var CashBackIcon = function CashBackIcon(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'm' : _props$size,
      rest = (0, _objectWithoutProperties2["default"])(props, ["size"]);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 12 14",
    fill: "none",
    style: sizes[size]
  }, rest), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.99999 0.333313H7.99999C9.84094 0.333313 11.3333 1.8257 11.3333 3.66665C11.3333 4.59707 10.9521 5.43845 10.3374 6.04314C10.1338 6.24336 9.8509 6.33126 9.56543 6.33328H5.5474L7.57596 4.30472C7.83631 4.04437 7.83631 3.62226 7.57596 3.36191C7.31561 3.10156 6.8935 3.10156 6.63315 3.36191L3.49932 6.49574C3.3034 6.69167 3.25491 6.97919 3.35387 7.22045C3.3864 7.30202 3.43569 7.37846 3.50172 7.44449L6.63316 10.5759C6.8935 10.8363 7.31561 10.8363 7.57596 10.5759C7.83631 10.3156 7.83631 9.89347 7.57596 9.63312L5.60946 7.66661H7.66661L9.55519 7.66665C9.84407 7.66665 10.1314 7.75424 10.3374 7.95682C10.9521 8.56151 11.3333 9.40289 11.3333 10.3333C11.3333 12.1743 9.84094 13.6666 7.99999 13.6666H1.99999C1.26361 13.6666 0.666656 13.0697 0.666656 12.3333V1.66665C0.666656 0.930267 1.26361 0.333313 1.99999 0.333313Z",
    fill: "url(#paint0_radial_1420_924)"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("radialGradient", {
    id: "paint0_radial_1420_924",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.33332 6.99998) rotate(180) scale(11 8.8)"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    "stop-color": "#00CAC1"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.34375",
    "stop-color": "#13B8DC"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.755208",
    "stop-color": "#386CDE"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    "stop-color": "#693CB8"
  }))));
};

var _default = /*#__PURE__*/(0, _react.memo)(CashBackIcon);

exports["default"] = _default;